var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19605_50394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99194 15.0381C12.3199 15.0381 15.0178 12.3403 15.0178 9.01226C15.0178 5.68426 12.3199 2.98639 8.99194 2.98639C5.66394 2.98639 2.96606 5.68426 2.96606 9.01226C2.96606 12.3403 5.66394 15.0381 8.99194 15.0381Z",
    fill: "#2EC4B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9865 14.4865V4.01351C14.9865 2.62534 13.8611 1.5 12.473 1.5H2C3.38818 1.5 4.51351 2.62534 4.51351 4.01351V14.4865C4.51351 15.4168 5.01898 16.2291 5.77027 16.6637",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9865 17C16.3747 17 17.5 15.8747 17.5 14.4865H7.02702C7.02702 15.4169 6.52155 16.2292 5.77026 16.6638C6.13997 16.8776 6.5692 17 7.02702 17H14.9865Z",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1.5V3.17568C2 3.6384 2.37511 4.01351 2.83784 4.01351H4.51351",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23657 4.85136H12.2636",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23657 7.36485H12.2636",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23657 9.87839H9.75009",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19605_50394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9755,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegal);
export default __webpack_public_path__ + "static/media/legal.e219fbd4e884fd8c9047febf29103bc6.svg";
export { ForwardRef as ReactComponent };